/**
 * InventoryDashboardPage
 * 
 * Landing page for the Inventory module.
 * Displays key metrics and quick access to inventory features.
 */

import { Package } from 'lucide-react';

export function InventoryDashboardPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <Package className="w-8 h-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-gray-900">ניהול מלאי</h1>
        </div>
        <p className="text-gray-600">
          מערכת ניהול מלאי מקיפה – תנועות, מוצרים, הזמנות B2B ודוחות
        </p>
      </div>

      {/* Placeholder for future dashboard widgets */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <Package className="w-16 h-16 text-gray-400 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          לוח בקרה בבנייה
        </h2>
        <p className="text-gray-600">
          כאן יוצגו סטטיסטיקות מלאי, תנועות אחרונות וגרפים
        </p>
      </div>
    </div>
  );
}
